import React from 'react';
import { Button } from 'reactstrap';

export type Currency = 'USD' | 'INR';

interface CurrencySelectorProps {
  selectedCurrency: Currency;
  onCurrencyChange: (currency: Currency) => void;
  className?: string;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  selectedCurrency,
  onCurrencyChange,
  className = '',
}) => {
  const currencies = [
    {
      code: 'USD' as Currency,
      name: 'USD',
      symbol: '$',
      flag: '🇺🇸',
      provider: 'Stripe',
    },
    {
      code: 'INR' as Currency,
      name: 'INR',
      symbol: '₹',
      flag: '🇮🇳',
      provider: 'Razorpay',
    },
  ];

  return (
    <div className={`currency-selector d-flex align-items-center justify-content-center gap-2 ${className}`}>
      <span className="text-muted small me-2">Currency:</span>
      {currencies.map((currency) => (
        <Button
          key={currency.code}
          color={selectedCurrency === currency.code ? 'primary' : 'outline-secondary'}
          size="sm"
          onClick={() => onCurrencyChange(currency.code)}
          className="d-flex align-items-center gap-1"
          style={{
            minWidth: '80px',
            fontWeight: selectedCurrency === currency.code ? '600' : '400'
          }}
        >
          <span style={{ fontSize: '1rem' }}>{currency.flag}</span>
          <span>{currency.symbol} {currency.name}</span>
        </Button>
      ))}
    </div>
  );
};

export default CurrencySelector;